/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-08T11:03:21.497
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentMaterialReceivingMainForm,
	listRentMaterialReceivingMainFormInit,
	listRentMaterialReceivingMainFormByAuthorizations,
	deleteRentMaterialReceivingMainForm
	
} from '@api/rentmanage/RentMaterialReceivingMainForm';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentMaterialReceivingMainForm({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentMaterialReceivingMainForm(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentMaterialReceivingMainFormByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentMaterialReceivingMainFormByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentMaterialReceivingMainFormInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentMaterialReceivingMainFormInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentMaterialReceivingMainForm({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentMaterialReceivingMainForm({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
